import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../material/material.module';
import { DailyLogConflictsDialogComponent } from './daily-log-conflicts-dialog.component';
import { DailyLogInsertPopupComponent } from './daily-log-insert-popup.component';

@NgModule({
  declarations: [DailyLogInsertPopupComponent, DailyLogConflictsDialogComponent],
  imports: [CommonModule, FormsModule, MaterialModule, MatIconModule],
  exports: [DailyLogInsertPopupComponent],
})
export class DailyLogInsertPopupModule {}
